import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
import LazyImage from './CustomLibraries/LazyImage';
SwiperCore.use([EffectFade, Autoplay]);
const SponsorLogoCard = ({ sponsor_logo }) => {
  const sponsorLogo = sponsor_logo?.split(',') ?? [];
  console.log('SPONSOR', sponsorLogo);
  return (
    <>
      {/* sponser logo if single ==========*/}
      {sponsorLogo.length == 1 && (
        <div className="crdV2sponser text-start m-0">
          <div className="crdV2sponserIn bg-white position-relative w-100">
            <LazyImage
              src={sponsorLogo[0]}
              className="position-absolute top-50 start-0 translate-middle-y"
              alt="sponsor"
              logo
            />
          </div>
        </div>
      )}
      {sponsorLogo.length == 0 && <div></div>}
      {/* sponser logo if single */}

      {/* sponser logo if multiple */}
      {sponsorLogo?.length > 1 && (
        <Swiper
          className="crdV2sponser text-start m-0"
          navigation={false}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 2500
          }}
          effect={'fade'}
        >
          {sponsorLogo?.map((logo, index) => (
            <SwiperSlide
              className="crdV2sponserIn bg-white position-relative w-100"
              key={index + 1}
            >
              <LazyImage
                src={logo}
                className="position-absolute top-50 start-0 translate-middle-y"
                alt="sponsor"
                logo
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default SponsorLogoCard;
